"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationAPI = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LocationAPI = /*#__PURE__*/function () {
  function LocationAPI(_ref) {
    var customerKey = _ref.customerKey;
    (0, _classCallCheck2.default)(this, LocationAPI);
    this.requestAuth = null;
    this.requestParameters = null;
    this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, customerKey);
  }

  (0, _createClass2.default)(LocationAPI, [{
    key: "getAllLocations",
    value: function getAllLocations(_ref2) {
      var pagination = _ref2.pagination;
      var pageSize = pagination['pageSize'];
      var currentPage = pagination['currentPage'];
      return this.requestAuth.get('AI_ROUTE', 'location-all', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        'limit': pageSize,
        'page': currentPage
      }));
    }
  }, {
    key: "getLocation",
    value: function getLocation(_ref3) {
      var locationId = _ref3.locationId;
      return this.requestAuth.get('AI_ROUTE', "location/".concat(locationId), _objectSpread({}, this.requestParameters));
    }
  }]);
  return LocationAPI;
}();

exports.LocationAPI = LocationAPI;